import { TableFilterControls, TableSortingControls } from "@/hooks/common/table";
import clsx from "clsx";
import { PropsWithChildren, ThHTMLAttributes, useId } from "react";
import { TableFilter } from "../TableFilter";
import { TableSort } from "../TableSort";

interface BaseProps extends ThHTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
}

type Props = BaseProps &
  /**
   * Sem ordenação e filtro
   */
  (
    | {
        sort?: never;
        filter?: never;
      }
    /**
     * Com ordenação
     */
    | {
        sort: TableSortingControls;
        filter?: never;
      }
    /**
     * Com filtro
     */
    | {
        sort?: never;
        filter: TableFilterControls;
      }
  );

export const TableColumn = ({ children, className, sort, filter, ...props }: Props) => {
  const labelId = useId();
  const classes = clsx("px-6 py-4 text-left font-normal whitespace-nowrap text-xs", className);

  if (sort) {
    return (
      <th
        className={classes}
        {...props}
        aria-sort={sort.isActive ? (sort.direction === "asc" ? "descending" : "ascending") : undefined}
      >
        <ActionWrapper>
          <TableSort {...sort} labelledBy={labelId}>
            {<p id={labelId}>{children}</p>}
          </TableSort>
        </ActionWrapper>
      </th>
    );
  }

  if (filter) {
    return (
      <th className={classes} {...props}>
        <ActionWrapper>
          <TableFilter {...filter} labelledBy={labelId}>
            {<p id={labelId}>{children}</p>}
          </TableFilter>
        </ActionWrapper>
      </th>
    );
  }

  return (
    <th className={classes} {...props}>
      {<p>{children}</p>}
    </th>
  );
};

const ActionWrapper = ({ children }: PropsWithChildren) => (
  <div className="flex items-center gap-2 text-left">{children}</div>
);
